<template>
  <v-card>
    <v-card-text class="secondary--text px-5 pt-5 titre-h4">
      Mes paramètres d'exploitation
    </v-card-text>
    <BaseMessageServerError v-if="erreur" />
    <BaseLoader v-if="loading" />
    <ParametresExploitationFormulaire
      v-else
      :loading-params="loading"
      :mise-a-jour="miseAJour"
      :parametres-exploitation="parametresExploitationModifiable"
      @change="onParamExploitationChange($event)"
    />
    <v-card-actions class="pa-4 mb-16 mb-md-0">
      <v-row no-gutters>
        <v-col
          v-if="nbAbandonsSupDix && !miseAJour"
          class="px-2 mb-3 mb-md-0"
          cols="12"
          md="4"
        >
          <AgrButton
            block
            large
            outlined
            @click="onClickPlusProposerModalParametreslues"
          >
            <div class="action primary--text">
              Ne plus me proposer
            </div>
          </AgrButton>
        </v-col>
        <v-col
          v-if="!miseAJour"
          :md="nbAbandonsSupDix ? '4' : '6'"
          class="px-2"
          cols="12"
        >
          <AgrButton
            block
            large
            outlined
            @click="onAnnuler"
          >
            <div class="action primary--text">
              Passer cette fois
            </div>
          </AgrButton>
        </v-col>
        <v-col
          :md="colonneEnregistrer"
          class="px-2 my-3 my-md-0"
          cols="12"
        >
          <AgrButton
            :disabled="isEnregistrementDisabled"
            block
            color="primary"
            large
            @click="updateParametreExploitation"
          >
            <div class="action white--text">
              Enregistrer
            </div>
          </AgrButton>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import { AgrButton } from '@agrial/ui'
import BaseLoader from '@/components/common/base-loader.vue'
import BaseMessageServerError from '@/components/common/base-message-server-error.vue'
import {clone} from '@/utils/clone'
import { mapActions, mapGetters } from 'vuex'
import ParametresExploitationFormulaire from '@/views/compte/components/formulaire-param-exploitation.vue'

export default {
  name: 'ParametresExploitationModal',
  components: { ParametresExploitationFormulaire, AgrButton, BaseLoader, BaseMessageServerError },
  props: {
    /*
     * Rappel bisannuel : les parametres sont deja renseignes, la seule sortie
     * est l'enregistrement. Ni "Passer cette fois", ni "Ne plus me proposer".
     */
    miseAJour: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      erreur: false,
      parametresExploitationModifiable: {},
      nbAbandonsSupDix: false
    }
  },

  computed: {
    ...mapGetters({
      parametresExploitation: 'parametresExploitation/parametresExploitation',
    }),
    /*
     * Le bouton d'enregistrement occupe toute la largeur quand il est seul.
     */
    colonneEnregistrer () {
      if (this.miseAJour) {
        return '12'
      }
      return this.nbAbandonsSupDix ? '4' : '6'
    },
    isEnregistrementDisabled () {
      return this.loading ||
        this.parametresExploitationModifiable.typeExploitation == null || this.parametresExploitationModifiable.typeExploitation.code === 'INCONNU' ||
        this.parametresExploitationModifiable.typeSol == null || this.parametresExploitationModifiable.typeSol.code === 'INCONNU' ||
        ((this.parametresExploitationModifiable.profondeurSol == null || this.parametresExploitationModifiable.profondeurSol < 30 || this.parametresExploitationModifiable.profondeurSol > 180)) ||
        this.parametresExploitationModifiable.typeProduction == null || this.parametresExploitationModifiable.typeProduction.code === 'INCONNU' ||
        this.parametresExploitationModifiable.ressourceEffluent == null || this.parametresExploitationModifiable.ressourceEffluent.code === 'INCONNU' ||
        this.parametresExploitationModifiable.stockageCereales == null || this.parametresExploitationModifiable.stockageCereales.code === 'INCONNU' ||
        (this.parametresExploitationModifiable.stockageCereales.code === 'VENTE' && this.parametresExploitationModifiable.capaciteStockage == null)
    },
  },
  watch: {
    parametresExploitation () {
      this.parametresExploitationModifiable = clone(this.parametresExploitation)
    }
  },
  created () {
    this.loadParametresExploitation()
    this.nbAbandonsSupDix = this.$cookies.get('PARAM_AUTRE_FOIS') != null && Number(this.$cookies.get('PARAM_AUTRE_FOIS')) >= 10
  },

  methods: {
    ...mapActions({
      getParametresExploitation: 'parametresExploitation/getParametresExploitation',
      getParametresExploitationComplet: 'parametresExploitation/getParametresExploitationComplet',
      createOrUpdateParametresExploitation: 'parametresExploitation/createOrUpdateParametresExploitation'
    }),

    loadParametresExploitation () {
      this.loading = true
      this.erreur = false

      this.getParametresExploitation()
        .then(() => {
          this.parametresExploitationModifiable = clone(this.parametresExploitation)
          this.getParametresExploitationComplet()
        })
        .catch(() => {
          this.erreur = true
        })
        .finally(() => {
          this.loading = false
        })
    },

    onParamExploitationChange (newParametre) {
      this.parametresExploitationModifiable = newParametre
    },

    onClickPlusProposerModalParametreslues () {
      this.$cookies.set('HAS_ABANDON_PARAM_MODAL', true)
      this.$emit('close', false)
    },
    onAnnuler () {
      if (this.$cookies.get('PARAM_AUTRE_FOIS') != null) {
        this.$cookies.set('PARAM_AUTRE_FOIS', Number(this.$cookies.get('PARAM_AUTRE_FOIS')) + 1)
      } else {
        this.$cookies.set('PARAM_AUTRE_FOIS', 1)
      }
      this.$emit('close', false)
    },
    updateParametreExploitation () {
      this.loading = true
      this.erreur = false

      if (this.parametresExploitationModifiable.stockageCereales.code !== 'VENTE') {
        this.parametresExploitationModifiable.capaciteStockage = null
      }
      this.createOrUpdateParametresExploitation(this.parametresExploitationModifiable)
        .then(() => {
          this.getParametresExploitationComplet()
          this.$emit('close', true)
        })
        .catch(() => {
          this.erreur = true
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.align-center {
  text-align: center;
}
.align-end {
  text-align: end;
}

.flex-center {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.radio-button {
  border: 1px solid grey;
  padding: 10px 30px;
  margin-top: 3px;
  margin-right: 3px;
  border-radius: 50px;
  width: 100%;
  &.is-active  {
    border-color: var(--v-primary-base);
  }
}
.potentiel-color-text {
  color: #969A27;
}

</style>
